import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { useBannerSize } from '../../../../common/hooks/use-banner-size';

export function GettingReadyBannerContent() {
  const { t } = useTranslation();
  const { h, fontSize } = useBannerSize();
  return (
    <Flex align="center" w="100%" h={h}>
      <Box flex={1} textAlign="center" pr={2} borderRadius="md">
        <Text fontSize={fontSize} letterSpacing="wider" data-testid="getting-ready-banner-title">
          {t('EVSE.getting ready title')}
        </Text>
        <Text fontSize="sm" data-testid="getting-ready-banner-body">
          {t('EVSE.getting ready body')}
        </Text>
      </Box>
    </Flex>
  );
}
